module.exports = __webpack_public_path__ + "img/mobile-anti-drooling-top.18e22697.png";